import React from "react"
import clockMarkers from "../clockMarkers"

function ClockTimer(props) {
    const markers = clockMarkers.map((value, index) => {
        return (
            <div key={index} className={"numberMarkerWrapper " + value}>
                <div className= "numberMarker numberMarkerTop"></div>
                <div className= "numberMarker numberMarkerBottom"></div>    
            </div>
        )
    })
    
    return(
        <div className="flipCardWrapper playingCardWrapper playingCardCountdown">
            <div className="countdownWrapper">
                <div className= "clockWrapper fourJokersClock">
                    <div className= "clockInner"></div>
                    {markers}
                    <div className="numberMarkerWrapper" id="secondHandRotate">
                        <div className= "clockHand minuteHand fourJokersHand"></div>
                    </div>
                    <div className="middleDot"></div>
                </div>

                <h1 className="timeRemaining">{props.timeLeft + " SECS"}</h1>
            </div>
        </div>
    )
}

export default ClockTimer